import { useEffect, useState } from "react"
import "./ScrollControl.less"
import { DataLayerFn } from "../../../Configs/API"
import FormStore from "../../../Configs/Store/forms"
import Image from "../Image/Image"
const ScrollControl = ({ targetRef, className, subItem, effectProps, columnNum = 1, scrollPercent, dataLayerEvent }) => {
  const [isLeft, setIsLeft] = useState(true)
  const [isRight, setIsRight] = useState(false)
  const [isScrolling, setIsScrolling] = useState(false)
  const [delayed, setDelayed] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setDelayed(true)
      handleChange()
    }, 3000)
  }, [])

  useEffect(() => {
    if (delayed) {
      handleChange()
      // console.info("ScrollManipulate effectProps")
    }
  }, [effectProps])

  useEffect(() => {
    // console.log(scrollPercent)
    if (scrollPercent === 0) {
      setIsLeft(true)
    } else if (scrollPercent === 100) {
      setIsRight(true)
    } else {
      setIsLeft(false)
      setIsRight(false)
    }
  }, [scrollPercent])

  const handleChange = async () => {
    var itemShownVar = await ItemShownValue()
    ScrollManipulate(itemShownVar)
  }

  const ItemShownValue = () => {
    var Gap
    try {
      Gap = Number(getComputedStyle(document.querySelector(".Recommended_List"))["columnGap"].replace("px", ""))
    } catch {
      Gap = 20
    }
    var parentClassWidth = document.querySelector(`.${className}`).offsetWidth
    var ChildClassWidth = document.querySelector(`.${className}Item.${subItem}`).offsetWidth + Gap
    var itemShownVar = parentClassWidth / ChildClassWidth
    // console.log(`ITem Show Var - ${className} - `, itemShownVar)
    var container = document.querySelector(`.${className}`)
    var listLength = container && container.children.length / columnNum
    if (itemShownVar >= listLength) {
      setIsLeft(true)
      setIsRight(true)
    }
    return Math.floor(itemShownVar)
  }
  const ScrollManipulate = (itemShown) => {
    try {
      var elem = document.querySelector(`.${className}Item.${subItem}`).offsetWidth
      var container = document.querySelector(`.${className}`)
      var scrollLeft = document.querySelector(`.${className}`).scrollLeft
      var columnGap = 30
      var listLength = container.children.length / columnNum

      var left = scrollLeft === 0

      setIsLeft(left)
      // listLength - 2 = Out of 10 Elements Column gap is shown for 8 SInce 1st & Last Element has no clumn gap before or after them respectively
      var LHS = elem * listLength + columnGap * (listLength - 2)
      // 5 = Total Items Shown at a time.
      // 4 = Total Column Gap shown in once section
      var RHS = elem * itemShown + columnGap * (itemShown - 1) + scrollLeft
      var right = LHS < RHS
      // setIsRight(right)
      // console.info("Scrollable :", scrollLeft, elem, listLength, LHS, RHS, itemShown)
      // console.log(left, right)
    } catch {
      setIsLeft(true)
      setIsRight(true)
    }
    setIsScrolling(false)
  }

  const ScrollTarget = (direction, offset) => {
    setIsScrolling(true)
    if (direction === "left") {
      targetRef.current.scrollLeft -= offset
      DataLayerFn(`${dataLayerEvent}_Previous||Calculator-Landing page|${dataLayerEvent}`, FormStore, "", "Scroll Left", "", "")
    } else if (direction === "right") {
      targetRef.current.scrollLeft += offset
      DataLayerFn(`${dataLayerEvent}_Next||Calculator-Landing page|${dataLayerEvent}`, FormStore, "", "Scroll Right", "", "")
    }

    setTimeout(handleChange, 1000)
  }

  return (
    <div className={`ScrollControl_Root${isScrolling ? " Scrolling" : ""}`}>
      <div className={`ScrollLeft ${isLeft ? "Scrolled" : "Scrollable"}`} onClick={() => ScrollTarget("left", 500)}>
        <Image src={"./assets/common/LeftIcon.svg"} alt={"Left"} />
      </div>
      <div className={`ScrollRight ${isRight ? "Scrolled" : "Scrollable"}`} onClick={() => ScrollTarget("right", 500)}>
        <Image src={"./assets/common/RightIcon.svg"} alt={"Right"} />
      </div>
    </div>
  )
}

export default ScrollControl
